export default __webpack_public_path__ + "static/media/old_de.b513baf1.jpg";